import React, { Component } from "react"
import { ProjectReadContainer, ProjectEditContainer } from "components/projects/redux/ProjectContainers"
import ProjectCardMineBasic from "components/projects/layout/ProjectCardMineBasic"
import ProjectCardAnyBasic from "components/projects/layout/ProjectCardAnyBasic"

export class ProjectMinePage extends Component { render() { return (<ProjectCardMineBasic />) } }
export class ProjectAnyPage extends Component { render() { return (<ProjectCardAnyBasic />) } }

export class ProjectReadPage extends Component { render() { return (<ProjectReadContainer projectId={this.props.match.params.projectId} />) } }
export class ProjectEditPage extends Component { render() { return (<ProjectEditContainer projectId={this.props.match.params.projectId} />) } }